import React from 'react'
import SidebarLayout from '../../Layouts/Sidebarlayout'
import '../../Assets/Css/AddUpdateEmployee.scss' 

const AddUpdateEmployee = () => {
  return (
    <SidebarLayout>
      <div className="addUpdateEmployee-main">
        <div className="page-title">
          <h4>Add Employee</h4>
          <div className="edit-btn">
            <button className="custom-btn">Save</button>
          </div>
        </div>
      </div>
    </SidebarLayout>
  )
}

export default AddUpdateEmployee
